export default __webpack_public_path__ + "static/media/WNo.8-0.bedaacdf.jpg";